export default Object.freeze({
  UploadFile: 1,
  DownloadFile: 2,
});
